export default "__VITE_ASSET__b429dc5a__"